const getEarliestTimestamp = (timestamps) => {
	// a timestamp has an lastSuccessfulExecution property that is an epoch timestamp
	// we need to find the timestamp with the lowest lastSuccessfulExecution
	return timestamps.reduce((earliest, current) => {
		return current.lastSuccessfulExecution < earliest.lastSuccessfulExecution ? current : earliest;
	}, timestamps[0]);
};

export { getEarliestTimestamp };
